import { Component } from '@angular/core';
import {
  ClientFeedbackCardComponent
} from "../../../shared/components/client-feedback-card/client-feedback-card.component";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-home-client-feedback',
  imports: [
    ClientFeedbackCardComponent,
    TranslatePipe
  ],
  templateUrl: './home-client-feedback.component.html',
  styleUrl: './home-client-feedback.component.scss'
})
export class HomeClientFeedbackComponent {
  clientFeedbacks = [
    {
      industry: 'Healthcare',
      feedback: 'home-page.clients-ogechukwu-text',
      reviewerName: 'home-page.clients-ogechukwu-ref',
      reviewerCompany: 'home-page.clients-ogechukwu-name',
      rating: 5
    },
    {
      industry: 'Public Sector',
      feedback: 'home-page.clients-min-of-health-text',
      reviewerName: 'home-page.clients-min-of-health-ref',
      reviewerCompany: 'home-page.clients-min-of-health-name',
      rating: 5
    },
    // private sector, IDI: Ihe development Initiative
    {
      industry: 'Public Sector',
      feedback: 'home-page.clients-min-of-house-text',
      reviewerName: 'home-page.clients-min-of-house-ref',
      reviewerCompany: 'home-page.clients-min-of-house-name',
      rating: 5
    },
    {
      industry: 'Healthcare',
      feedback: 'home-page.clients-momh-text',
      reviewerName: 'home-page.clients-momh-ref',
      reviewerCompany: 'home-page.clients-momh-name',
      rating: 5
    }
  ];
}
